module.exports = __webpack_public_path__ + "img/op_como-funciona-relink-1.def237c.png";